import { render, staticRenderFns } from "./ProcessComponentModelList.vue?vue&type=template&id=312f1224&"
import script from "./ProcessComponentModelList.vue?vue&type=script&lang=js&"
export * from "./ProcessComponentModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports